import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';

export const Okay = ({ color }) => (
  <SentimentSatisfiedIcon fontSize="large" sx={{ color }} />
);
